import { translateString } from '@src/util/intl/translateString';

export const isDev = process.env.NODE_ENV !== 'production';

export const SCHEDULE_TYPES = {
  schedule: 'schedule',
  task: 'task',
  checkpoint_route: 'checkpoint_route',
};

export const LOC_TYPES = {
  GPS: 'GPS',
  NFC: 'NFC',
  QR: 'QR',
  BEACON: 'BEACON',
};

export const SCHEDULE_STATUS = {
  active: 'active',
  pending: 'pending',
  completed: 'completed',
  expired: 'expired',
};

// Components of forms
export const TYPE_OF_COMPONENTS = {
  FILE: 'file',
  NUMBER: 'number',
  PHOTO: 'photo',
  TAG: 'tag',
  TEXT: 'text',
  TOGGLE: 'toggle',
  VIDEO: 'video',
  SELECT: 'select',
  DATE: 'date',
  SIGNATURE: 'signature',
  LIST_SELECT: 'listSelect',
};

// LAYOUT FORM
export const FORM_LAYOUT_DEFAULT = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 24,
  },
};

export const WEEKS_VALUE_TRANSLATED = {
  1: translateString('general.day.monday'),
  2: translateString('general.day.tuesday'),
  3: translateString('general.day.wednesday'),
  4: translateString('general.day.thursday'),
  5: translateString('general.day.friday'),
  6: translateString('general.day.saturday'),
  0: translateString('general.day.sunday'),
};

export const DAYS_OF_WEEK = [
  {
    label: translateString('general.day.monday'),
    value: 1,
    short: translateString('general.short.day.mon'),
    order: 0,
  },
  {
    label: translateString('general.day.tuesday'),
    value: 2,
    short: translateString('general.short.day.tue'),
    order: 1,
  },
  {
    label: translateString('general.day.wednesday'),
    value: 3,
    short: translateString('general.short.day.wed'),
    order: 2,
  },
  {
    label: translateString('general.day.thursday'),
    value: 4,
    short: translateString('general.short.day.thu'),
    order: 3,
  },
  {
    label: translateString('general.day.friday'),
    value: 5,
    short: translateString('general.short.day.fri'),
    order: 4,
  },
  {
    label: translateString('general.day.saturday'),
    value: 6,
    short: translateString('general.short.day.sat'),
    order: 5,
  },
  {
    label: translateString('general.day.sunday'),
    value: 7,
    short: translateString('general.short.day.sun'),
    order: 6,
  },
];

export const FIREBASE_AUTH_ERROR_CODES = {
  WRONG_PASSWORD: 'auth/wrong-password',
  TOO_MANY_REQUESTS: 'auth/too-many-requests',
  USER_MISMATCH: 'auth/user-mismatch',
  USER_NOT_FOUND: 'auth/user-not-found',
  NETWORK_REQUEST_FAILED: 'auth/network-request-failed',
};

export const DASHBOARD_ITEM_API_NAMES = {
  NUMBER_METRICS_DASHBOARD: 'numberMetricsDashboard',
  TABLE_DASHBOARD: 'tableDashboard',
  SCHEDULES_COMPLIANCE: 'schedulesCompliance',
  SCHEDULES_COMPLIANCE_HIST: 'schedulesComplianceHist',
  COMPONENTS_DETAIL: 'componentsDetail',
  HISTOGRAM_BY_EVENTS: 'histogramByEvents',
  EVENTS_COUNTER: 'eventsCounter',
  SCHEDULES_COMPLETION: 'schedulesCompletion',
  EXECUTION_RECORDS_DASHBOARD: 'executionRecordsDashboard',
  EVENT_COUNTER_NUMBER_COMPONENT: 'eventCounterNumberComponent',
};

export const DEFAULT_SORT = [{ field: 'createdAt._seconds', order: 'desc' }];
